/**
 * index
 */

export * from './object.utils';
export * from '../../../../legacy-utils/testing';

export const getDoubleDigitTime = (val: Number = 0) => val.toString().padStart(2, '0');
